<template>
 <div>
   <div @click="dialog=true" class="w-60 g-box  mb-10 ma-auto">
     <v-img class="mb-3" style="position: relative" :src="item.photo_file">
       <div class="date-box" >
         <span class="d-flex align-center justify-center">
        {{item.title}}
      </span>
       </div>
     </v-img>
   </div>

     <v-dialog persistent  width="500" class="d-flex justify-center align-center text-center"  v-model="dialog">
       <v-card  width="500" height="100%">
         <v-app-bar>
           <v-icon @click="closeModal">mdi-close</v-icon>
         </v-app-bar>
         <video width="500" ref="attach-video" v-if="item.attach_file" controls>
          <source :src="item.attach_file" type="video/mp4">
          Your browser does not support the video tag.
        </video> 
         <img alt="image" style="object-fit: fill" width="500" v-else-if="item.photo_file" :src="item.photo_file" />

       </v-card>
     </v-dialog>
 </div>
</template>

<script>
export default {
  name: "BlockGalleryItem",
  data(){
    return{
      dialog:false,
    }
  },
  props:{
    item:Object
  },
  methods:{
    closeModal(){
      this.dialog=false
      this.$refs['attach-video'].pause();
      this.$refs['attach-video'].currentTime = 0;
    }
  }
}
</script>

<style scoped>
.date-box {
  padding: 6px 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}

.g-box:hover > * > * > .date-box {
  background-color: #0846be;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}

.date-box > * {
  color: white;
  font-size: 16px !important;
}
</style>